// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetProjectSummary  {
    _originalTypeClassName = "Loom.BO.TimesheetProjectSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetProjectSummary.translate = translateService;
}
this.Id = null;
this.Forecast = null;
this.Actual = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Forecast:any;
Actual:any;
Project:any;
Timesheet:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setTimesheet = ($this, value) => {
var oldValue = $this.Timesheet;
$this.Timesheet = value;
if (value != null) {
if (oldValue != null) {
Domain.Timesheet.removeProjects(oldValue, $this);
}
Domain.Timesheet.addProjects(value, $this);
}
}

static GetActual($this: any): any{if (($this?.Project == null)) {return $this?.Actual;}
return $this?.Timesheet?.TimesheetEntries?.linq?.where((e) => CLMS.Framework.Number.Equal(() => e.WorkPackage.Project.Id, () => $this.Project.Id))?.toArray()?.linq?.sum((e) => e?.HoursWorked);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}